export const getMessageLocalStorageKey = (): string => `draft-message-for-${window.location.pathname}`;

export const MAX_FILES_COUNT = 10;
/**
 * Предел размера вложения. Бэкенд отказывает выше 1536 Мбайт (S3Service::MAX_FILE_SIZE_MB), и до
 * SINGULAR-3224 здесь стояло 2048: файл между полутора и двумя гигабайтами проходил проверку, а
 * подписи на загрузку не получал, и студент видел «Ошибка загрузки файла по сети» — не отличить от
 * обрыва связи. Число опущено до размера, который реально доезжает: полтора гигабайта уходят одним
 * куском без докачки минут десять и рвутся, а пятиминутное видео с телефона в 1080p весит меньше
 * пятисот мегабайт. Всё, что больше, студенту предлагается сжать или выложить на видеосервис.
 */
export const MAX_FILE_SIZE_MB = 500;

export enum AttachmentStatus {
  uploading = 'uploading',
  uploaded = 'uploaded',
  error = 'error',
}
